import React from 'react';
import PropTypes from 'prop-types';
import { TextField as MuiTextField } from '@mui/material';

// Component scope - Constants and static data
const TEXT_FIELD_VARIANTS = ['outlined', 'filled', 'standard'];
const TEXT_FIELD_TYPES = ['text', 'email', 'password', 'number', 'tel', 'url'];

/**
 * App TextField Component - Wrapper for MUI TextField
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppTextFieldComponent
 */
const AppTextFieldComponent = ({
  variant = 'outlined',
  type = 'text',
  label,
  placeholder,
  value,
  onChange,
  error = false,
  helperText,
  required = false,
  disabled = false,
  fullWidth = false,
  multiline = false,
  rows,
  inputProps,
  ...props
}) => {
  // Return/rendering
  return (
    <MuiTextField
      variant={variant}
      type={type}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      required={required}
      disabled={disabled}
      fullWidth={fullWidth}
      multiline={multiline}
      rows={rows}
      inputProps={inputProps}
      {...props}
    />
  );
};

AppTextFieldComponent.propTypes = {
  variant: PropTypes.oneOf(TEXT_FIELD_VARIANTS),
  type: PropTypes.oneOf(TEXT_FIELD_TYPES),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  name: PropTypes.string,
  id: PropTypes.string,
  sx: PropTypes.object,
  inputProps: PropTypes.object,
};

export default AppTextFieldComponent;

